import { Backdrop as BackdropMUI, Stack, Typography, styled } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { PropsWithChildren } from "react";

interface ISimpleBackdrop extends PropsWithChildren {
  open: boolean;
  text: string;
}

const Backdrop = styled(BackdropMUI)(({ theme }) => ({
  color: theme.palette.text10.main,
  //one more than the default zIndex drawer
  zIndex: theme.zIndex.drawer + 1,
}));
const SimpleBackdrop = ({ open, text }: ISimpleBackdrop) => {
  return (
    <div>
      <Backdrop open={open} title={text}>
        <Stack direction="column" spacing={2} sx={{ justifyContent: "center", alignItems: "center" }}>
          <CircularProgress color="inherit" />
          <Typography>{text}</Typography>
        </Stack>
      </Backdrop>
    </div>
  );
};

export { SimpleBackdrop };
